import React, { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { Loader2 } from 'lucide-react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import ChatInterface from './ChatInterface';
import ProfileSelection from './ProfileSelection';
import FloatingCalculator from './FloatingCalculator';
import { initAnalytics, identifyUser, track } from './analytics';
import './App.css';

function AppRoutes() {
  const { initialized, keycloak } = useKeycloak();

  // Initialise GA4 once, and identify the signed-in user (hashed id + role/bot).
  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    if (initialized && keycloak.authenticated) {
      const tp: any = keycloak.tokenParsed || {};
      const realmRoles: string[] = tp.realm_access?.roles || [];
      const clientRoles: string[] = tp.resource_access?.[keycloak.clientId as string]?.roles || [];
      const roles = Array.from(new Set([...realmRoles, ...clientRoles]));
      identifyUser(tp.preferred_username || tp.email, {
        role: roles.join(',').slice(0, 90),
      });
      track('login', { has_roles: roles.length });
    }
  }, [initialized, keycloak.authenticated, keycloak]);

  if (!initialized) {
    return (
      <div className="app">
        <div className="loading-screen">
          <Loader2 className="spin" size={48} />
          <p>Initializing authentication...</p>
        </div>
      </div>
    );
  }

  if (!keycloak.authenticated) {
    return (
      <div className="app">
        <div className="loading-screen">
          <Loader2 className="spin" size={48} />
          <p>Redirecting to login...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/select" replace />} />
        <Route path="/select" element={<ProfileSelection />} />
        <Route path="/chat" element={<ChatInterface />} />
        <Route path="*" element={<Navigate to="/select" replace />} />
      </Routes>
      {/* Floating, draggable, closable calculator — available on every screen */}
      <FloatingCalculator />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
